import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid2,
  Link,
} from '@mui/material';
import { Link as RouterLink } from 'gatsby';
import React from 'react';

import ContentLoader from '@components/ContentLoader';
import IconButton from '@components/IconButton';

interface ILink {
  title: string;
  value: string;
}

interface LinksCardProps {
  title: string;
  loading: boolean;
  data: ILink[];
  onEdit?: () => void;
}

const LinksCard = ({
  data,
  loading,
  title,
  onEdit,
}: React.PropsWithChildren<LinksCardProps>) => {
  const handleEdit = () => {
    onEdit?.();
  };

  return (
    <Card>
      <CardHeader
        title={title}
        action={
          onEdit ? (
            <IconButton name="pen" iconType="fad" onClick={handleEdit} />
          ) : null
        }
      />
      <Divider />
      <CardContent>
        <ContentLoader loading={loading}>
          <Grid2 container spacing={1}>
            {data.map(({ title, value }) => (
              <Grid2 size={{ xs: 12 }} key={title}>
                <Link component={RouterLink} to={value} color="info.main">
                  {title}
                </Link>
              </Grid2>
            ))}
          </Grid2>
        </ContentLoader>
      </CardContent>
    </Card>
  );
};

export default LinksCard;
